import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, HostListener, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FadvBaseComponent, Track, Forward, FadvCommonModule } from '@fa-switch-sharedservices/ng-elements/common';
import '@fa-switch-sharedservices/web-elements/components/progress-dots/progress-dots';

class FadvProgressDotComponent extends FadvBaseComponent {
    constructor() {
        super(...arguments);
        this.active = false;
        this.value = '';
        this.activeChange = new EventEmitter();
        this.activated = new EventEmitter();
        this.deactivated = new EventEmitter();
    }
    handleProgressDotActivated() {
        this.activeChange.emit(true);
        this.activated.emit();
    }
    handleProgressDotDeactivated() {
        this.activeChange.emit(false);
        this.deactivated.emit();
    }
}
FadvProgressDotComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvProgressDotComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
FadvProgressDotComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvProgressDotComponent, selector: "fadv-progress-dot", inputs: { active: "active", value: "value" }, outputs: { activeChange: "activeChange", activated: "activated", deactivated: "deactivated" }, host: { listeners: { "progress-dot-activated": "handleProgressDotActivated()", "progress-dot-deactivated": "handleProgressDotDeactivated()" } }, usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
__decorate([
    Track()
], FadvProgressDotComponent.prototype, "activated", void 0);
__decorate([
    Track()
], FadvProgressDotComponent.prototype, "deactivated", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvProgressDotComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fadv-progress-dot', template: '<ng-content></ng-content>' }]
        }], propDecorators: { active: [{
                type: Input
            }], value: [{
                type: Input
            }], activeChange: [{
                type: Output
            }], activated: [{
                type: Output
            }], deactivated: [{
                type: Output
            }], handleProgressDotActivated: [{
                type: HostListener,
                args: ['progress-dot-activated']
            }], handleProgressDotDeactivated: [{
                type: HostListener,
                args: ['progress-dot-deactivated']
            }] } });

class FadvProgressDotsComponent extends FadvBaseComponent {
    constructor() {
        super(...arguments);
        this.activeDotChange = new EventEmitter();
    }
    handleActiveDotChange(event) {
        const customEvent = event;
        this.activeDotChange.emit(customEvent.detail.activeDot);
    }
}
FadvProgressDotsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvProgressDotsComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
FadvProgressDotsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvProgressDotsComponent, selector: "fadv-progress-dots", inputs: { activeDot: "activeDot" }, outputs: { activeDotChange: "activeDotChange" }, host: { listeners: { "progress-dots-active-change": "handleActiveDotChange($event)" } }, usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
__decorate([
    Forward()
], FadvProgressDotsComponent.prototype, "activeDot", void 0);
__decorate([
    Track()
], FadvProgressDotsComponent.prototype, "activeDotChange", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvProgressDotsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fadv-progress-dots', template: '<ng-content></ng-content>' }]
        }], propDecorators: { activeDot: [{
                type: Input
            }], activeDotChange: [{
                type: Output
            }], handleActiveDotChange: [{
                type: HostListener,
                args: ['progress-dots-active-change', ['$event']]
            }] } });

class FadvProgressDotsModule {
}
FadvProgressDotsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvProgressDotsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FadvProgressDotsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: FadvProgressDotsModule, declarations: [FadvProgressDotsComponent, FadvProgressDotComponent], imports: [FadvCommonModule], exports: [FadvProgressDotsComponent, FadvProgressDotComponent] });
FadvProgressDotsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvProgressDotsModule, imports: [FadvCommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvProgressDotsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FadvProgressDotsComponent, FadvProgressDotComponent],
                    imports: [FadvCommonModule],
                    exports: [FadvProgressDotsComponent, FadvProgressDotComponent],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { FadvProgressDotComponent, FadvProgressDotsComponent, FadvProgressDotsModule };
